import axios from "axios";
import {Base_URL} from "../url"

export const fetchEventApprovalData = async () => {
    try {
      const response = await axios.get(`${Base_URL}/ApprovalEventDetails/ApprovalEventData`);
      return response.data;
    } catch (error) {
      console.error("Error fetching event approval data:", error);
      throw error;
    }
  };
  
  export const sendEventApprovalRequest = async (eventId) => {
    try {
      await axios.put(`${Base_URL}/ApprovalEventDetails/UpdateEventAproval?EventId=${eventId}`);
    } catch (error) {
      console.error("Error sending event approval request:", error);
      throw error;
    }
  };